/**
* @params Scroll Bar
*/

export default function () {
  const winWidth=$(window).width();
  if (winWidth<1024) {
    $('.js-custom-scroll').mCustomScrollbar({
      axis: 'y',
      theme: 'dark',
    });
  }
  if (winWidth>1023) {
    $('.header__left, .js-custom-scroll').mCustomScrollbar({
      axis: 'y',
      theme: 'dark',
    });
  }
}
